import { Text } from '@/components/text';
import { ThemedView } from '@/components/themed-view';
import { Link, Stack, usePathname } from 'expo-router';
import { StyleSheet } from 'react-native';

export default function NotFoundScreen() {
  const pathname = usePathname();

  return (
    <>
      <Stack.Screen options={{ title: 'Oops!' }} />
      <ThemedView style={styles.container}>
        <Text type='title'>This screen doesn't exist. {pathname}</Text>
        <Link href='/' style={styles.link}>
          <Text type='link'>Go to home screen!</Text>
        </Link>
      </ThemedView>
    </>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
  },

  link: {
    marginTop: 15,
    paddingVertical: 15,
  },
});
